import React from 'react';

// Minimal, cheapest background: single static image (background.png).
// Place `background.png` in the public folder so it is served at `/background.png`.
const BackgroundLogins = () => {
  const style = {
    backgroundImage: "url('/background.png')",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    pointerEvents: 'none',
  };

  return (
    <div className="fixed inset-0 -z-50">
      <div className="absolute inset-0 bg-sky-50" style={style} />
    </div>
  );
};

export default BackgroundLogins;
